import t from"./_getMapData.js";var s=t;var a=function(t,a){var e=s(this,t),i=e.size;return e.set(t,a),this.size+=e.size==i?0:1,this};export{a as default};
//# sourceMappingURL=_mapCacheSet.js.map
